import React, { useContext } from 'react';
import { useSelector } from 'react-redux';
import { makeStyles } from '@material-ui/core';
import Typography from '@material-ui/core/Typography';
import ErrorIcon from '@material-ui/icons/Error';
import { FormattedMessage } from 'react-intl';
import format from 'date-fns/format';
import FormContext from '../FormContext';
import {
  getLanguage,
  getConfigs,
  getMarketLanguage,
  getMarketName,
  getMarketDisplayName
} from '../../../features/app/selectors';
import { useLocation } from 'react-router-dom';
import { Public } from '@material-ui/icons';
import { toJS } from 'utils/immutableUtils';

const useStyles = makeStyles(theme => ({
  root: {
    display: 'flex',
    alignItems: 'center',
    ...theme.mixins.gutters({
      paddingTop: theme.spacing(2),
      paddingBottom: theme.spacing(2)
    })
  },
  title: {
    fontWeight: 400
  },
  titleContext: {
    lineHeight: 1
  },
  spacer: {
    flexGrow: '1',
    minWidth: '2%'
  },
  longPanel: {
    flexGrow: '1',
    minWidth: '20%'
  },
  metaValue: {
    color: theme.palette.text.primary
  },
  placeholder: { color: theme.warning },
  icon: { width: '0.9em', marginRight: '0.3rem' },
  publicIcon: {
    marginBottom: '-5px',
    marginRight: '10px'
  }
}));

const Header = ({ useMarketLanguage }) => {
  const classes = useStyles();
  const languages = useSelector(getLanguage);
  const marketlanguage = useSelector(getMarketLanguage);
  const { getDataLabels } = useContext(FormContext);
  const language = useMarketLanguage ? marketlanguage : languages;
  const marketList = useSelector(getMarketDisplayName);
  const marketNames = useSelector(getMarketName);
  const userMarket = toJS(marketList, []);
  const location = useLocation();
  const { title, titleContext, modifiedDate, modifiedBy } = getDataLabels(
    language
  );
  function createMarketDisplayLabel(data) {
    if (Array.isArray(data)) {
      const filteredData = data.filter(i => i.countryCode === marketNames);
      return filteredData.length > 0 ? filteredData[0] : null; // Return the first matching object or null
    }
    return null; // Return null if data is not an array
  }

  const marketLabelToDisplay = createMarketDisplayLabel(userMarket);
  // console.log(marketLabelToDisplay,"userMarket")
  const dateFormat = useSelector(getConfigs).toJS().dateFormat || +'yyyy-MM-dd';
  const modifiedDateFormatted =
    modifiedBy && format(new Date(modifiedDate), `${dateFormat} HH:mm`);
  return (
    <div className={classes.root} data-testid="form-header">
      {location.pathname === '/marketSettings' ? (
        <div>
          <Typography variant="h6" className={classes.title}>
            <Public className={classes.publicIcon} />
            {marketLabelToDisplay && marketLabelToDisplay.displayLabel}
          </Typography>
        </div>
      ) : (
        <div>
          {titleContext && titleContext.length > 0 && (
            <Typography variant="overline" className={classes.titleContext}>
              {titleContext}
            </Typography>
          )}
          {title && title.trim().length > 0 ? (
            <Typography variant="h6" className={classes.title}>
              {title}
            </Typography>
          ) : (
            <Typography variant="button" className={classes.placeholder}>
              <ErrorIcon className={classes.icon} />
              <FormattedMessage id="form.noTitle" />
            </Typography>
          )}
        </div>
      )}
      <div className={classes.spacer} />
      {modifiedBy && modifiedDate.length > 0 && (
        <div className={classes.longPanel}>
          <Typography variant="caption" align="right" component="div">
            <FormattedMessage id="form.lastModifiedBy" />: {modifiedBy}{' '}
            {modifiedDateFormatted}
          </Typography>
        </div>
      )}
    </div>
  );
};

export default Header;
